module.exports = __webpack_public_path__ + "static/media/spinner-third.f1d3bba8.svg";